import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { ReflectionsProvider as Provider } from '../../components/context/reflections-context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const REFLECTIONS_QUERY = graphql`
query NodeAllReflectionsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Reflections" } }) {
    nodes {
      data
    }
  }
}
`;

export const ReflectionsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(REFLECTIONS_QUERY), 'items')}>{children}</Provider>;
};
